var map = {
	"./admin.svg": "ced6",
	"./class2.svg": "5592",
	"./class22.svg": "e103",
	"./classRp.svg": "0eb9",
	"./classRp2.svg": "e686",
	"./classRp3.svg": "c59d",
	"./close_icon.svg": "c4fd",
	"./dashboard.svg": "f782",
	"./data_board.svg": "747b",
	"./device.svg": "2c87",
	"./download.svg": "4dae",
	"./exam.svg": "a978",
	"./example.svg": "30c3",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./form.svg": "eb1b",
	"./interact.svg": "25a0",
	"./interact2.svg": "0535",
	"./link.svg": "18f0",
	"./nested.svg": "dcf8",
	"./operator.svg": "7ed9",
	"./password.svg": "2a3d",
	"./report.svg": "9e5c",
	"./report2.svg": "822d",
	"./student2.svg": "44d4",
	"./subject.svg": "fab3",
	"./table.svg": "47f1",
	"./task_report.svg": "e240",
	"./teacher.svg": "361d",
	"./teacher_report.svg": "5296",
	"./tree.svg": "93cd",
	"./user.svg": "b3b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";